/**
 * Subregel van het identiteitsblok: "GHOR · Veiligheidsregio Utrecht".
 * Ontbrekende delen vallen weg zonder losse scheidingsstreep.
 */
export function organisationLabel(
  perspectiveName: string | null | undefined,
  tenantLabel: string | null,
): string {
  return [perspectiveName, tenantLabel].filter(Boolean).join(' · ');
}
